import { Component, ViewEncapsulation } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HelpIndex, EntryType, Endpoint, PasswordListOperationType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import * as _ from 'underscore';

@Component({
    standalone: false,
    selector: 'res-add-passwords-modal',
    templateUrl: './add-passwords-modal.component.html',
    styleUrls: ['./add-passwords-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class AddPasswordsModalComponent extends BaseModalComponent {
    modalTitle = 'Add Passwords';
    modalAutomationId = 'add-passwords-modal';
    secondaryButtonLabel = 'Cancel';
    primaryButtonLabel = 'OK';
    verifyRequiredValidator = true;
    isBusy = false;
    isBusyMessage = '';
    modalHelpIndex = HelpIndex.password_add_passwords_dlg;
    modalClass = 'add-passwords-modal';
    allEntries = [{ name: '' }];
    availableEntries = [];
    passwordCount = 0;
    passwordsToSend = [];
    loadedFromFile = false;
    fileName = '';
    clearButtonName = 'Clear All';


    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    isPrimaryButtonEnabled() {
        return this.allEntries.length > 1 || this.loadedFromFile;
    }

    newFileUploaded($event): void {
        this.readFileContent($event.target);
    }

    readFileContent(inputValue: any): void {
        const file: File = inputValue.files[0];
        const fileReader: FileReader = new FileReader();
        this.passwordsToSend = [];

        fileReader.onloadend = e => {
            let result;
            if (fileReader.result instanceof ArrayBuffer) {
                result = String.fromCharCode.apply(null, new Uint16Array(fileReader.result));
            } else {
                result = fileReader.result.split('\n');
            }
            this.passwordsToSend = this.retUniquePasswords(result.map(t => t.replace(/\r?\n|\r/g, '')).filter(entry => { return entry.length > 0 }));
            this.loadedFromFile = true;
            this.passwordCount = this.passwordsToSend.length;
        };

        fileReader.readAsText(file);
        this.fileName = file.name;
        this.clearButtonName = 'Remove File';
    }

    retUniquePasswords(passwords: any[]): any[] {
        if (passwords.length > 0) {
            const uniquePasswords: Set<any> = new Set(passwords);
            return [...uniquePasswords];
        }
        return [];
    }

    clearAllEntries() {
        this.allEntries = [];
        this.allEntries.push({ name: '' });
        this.loadedFromFile = false;
        this.passwordsToSend = [];
        this.passwordCount = 0;
        this.fileName = '';
        this.clearButtonName = 'Clear All';
    }

    queriesChanged(): void {
        this.passwordCount = this.allEntries.length - 1;
    }

    OK() {
        const endpoint = Endpoint.projectManager_addToPasswordList;

        if (!this.loadedFromFile) {
            this.allEntries.forEach((singleEntry) => {
                if (singleEntry.name !== '' && !this.passwordsToSend.includes(singleEntry.name)) {
                    this.passwordsToSend.push(singleEntry.name);
                }
            });
        }

        const request = {
            passwordListType: this.modalData.modalType,
            passwords: this.passwordsToSend,
            deleteAll: false,
            passwordListOperationType: this.loadedFromFile ? PasswordListOperationType.ADD_FILE : PasswordListOperationType.ADD_MANUAL,
            projectId: this.modalData.handle,
            source: this.loadedFromFile ? this.fileName : '',
        };

        this.restService.post(endpoint, request).then(response => {
            this.closeModal(true, response);
        }, error => {
            console.error(error);
        });
    }
}
